export class DealPermissionConstants {
  public static readonly WRITE_DEAL = "writeDeal";

  public static readonly MANAGE_DEAL = "manageDeal";
}
